import { AddIcon, Button } from "@eworkit/iris";
import React, { FC, useCallback } from "react";
import { useDialogState } from "reakit/Dialog";

import AddNewProfileDialog from "@/views/Invitations/AddNewProfileDialog";

interface InviteButtonProps {}

export const InviteButton: FC<InviteButtonProps> = ({ ...buttonProps }) => {
  const addNewProfileDialogState = useDialogState({ animated: true });

  const handleClick = useCallback(() => {
    addNewProfileDialogState.show();
  }, [addNewProfileDialogState]);

  return (
    <>
      <Button size="sm" iconLeft={<AddIcon />} onClick={handleClick} {...buttonProps} />

      <AddNewProfileDialog dialogState={addNewProfileDialogState} />
    </>
  );
};
